import React, { useState, useEffect } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import CommonTextField from "presentational/common/CommonTextField";
import TXT from "presentational/common/multinational/TXT";
import Typography from "@material-ui/core/Typography";
import { removeSpaceFromText } from "lib/commonUtil";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const MAX_LENGTH_OF_NICKNAME = 50;
const MAX_LENGTH_OF_PLACE = 200;
const MAX_LENGTH_OF_SIZE_DETAIL = 200;
const MAX_LENGTH_OF_MEMO = 400;

const css = {
  paper: {
    marginLeft: 0,
    marginRight: 0,
    width: "90%"
  }
};

const WarningTypography = withStyles({
  root: {
    fontSize: 12
  }
})(Typography);

ItemNoteInputModalView.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  nickname: PropTypes.string,
  place: PropTypes.string,
  sizeDetail: PropTypes.string,
  memo: PropTypes.string,
  onMemoSubmit: PropTypes.func.isRequired
};

function ItemNoteInputModalView(props) {
  const { open, onClose, nickname, place, sizeDetail, memo, onMemoSubmit } =
    props;
  const [tempNickname, setTempNickname] = useState("");
  const [tempPlace, setTempPlace] = useState("");
  const [tempSizeDetail, setTempSizeDetail] = useState("");
  const [tempMemo, setTempMemo] = useState("");

  useEffect(() => {
    setTempNickname(nickname || "");
    setTempPlace(place || "");
    setTempSizeDetail(sizeDetail || "");
    setTempMemo(memo || "");
  }, [nickname, place, sizeDetail, memo]);

  const getMaxLength = type => {
    let maxLength;
    switch (type) {
      case "nickname":
        maxLength = MAX_LENGTH_OF_NICKNAME;
        break;
      case "place":
        maxLength = MAX_LENGTH_OF_PLACE;
        break;
      case "sizeDetail":
        maxLength = MAX_LENGTH_OF_SIZE_DETAIL;
        break;
      case "memo":
        maxLength = MAX_LENGTH_OF_MEMO;
        break;

      default:
        console.error(`wrong type : "${type}"`);
        break;
    }
    return maxLength;
  };

  const cutExceedText = (type, inputText) => {
    if (typeof inputText !== "string") return "";
    const maxLength = getMaxLength(type);
    return inputText.length > maxLength
      ? inputText.slice(0, maxLength)
      : inputText;
  };

  const handleChange = type => e => {
    const { value } = e.target;
    if (getMaxLength(type) < value.length) return null;

    switch (type) {
      case "nickname":
        setTempNickname(value);
        break;
      case "place":
        setTempPlace(value);
        break;
      case "sizeDetail":
        setTempSizeDetail(value);
        break;
      case "memo":
        setTempMemo(value);
        break;

      default:
        console.error(`wrong type : "${type}"`);
        break;
    }
  };

  const handleSaveBtnClick = () => {
    let nicknameV2 = removeSpaceFromText(tempNickname);
    let placeV2 = removeSpaceFromText(tempPlace);
    let sizeDetailV2 = removeSpaceFromText(tempSizeDetail);
    let memoV2 = removeSpaceFromText(tempMemo);

    nicknameV2 = cutExceedText("nickname", nicknameV2);
    placeV2 = cutExceedText("place", placeV2);
    sizeDetailV2 = cutExceedText("sizeDetail", sizeDetailV2);
    memoV2 = cutExceedText("memo", memoV2);

    onMemoSubmit({
      nickname: nicknameV2,
      place: placeV2,
      sizeDetail: sizeDetailV2,
      memo: memoV2,
      hasNicknameChanged: nickname !== nicknameV2
    });

    setTempNickname(nicknameV2);
    setTempPlace(placeV2);
    setTempSizeDetail(sizeDetailV2);
    setTempMemo(memoV2);

    onClose();
  };

  return (
    <CommonModalView
      open={open}
      onClose={onClose}
      paperStyle={css.paper}
      titleText={<TXT name="titleModal_writeItemMemo" />}
      contentComponent={
        <div>
          <div>
            <WarningTypography>
              <TXT name="msg_doNotSavePassword" />
            </WarningTypography>
          </div>
          <CommonTextField
            label={<TXT name="wordPlaceholder_itemName" />}
            value={tempNickname}
            shrinkLabel
            errorText={
              getMaxLength("nickname") <= tempNickname.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("nickname")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_itemLocation" />}
            value={tempPlace}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("place") <= tempPlace.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("place")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_itemSize" />}
            value={tempSizeDetail}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("sizeDetail") <= tempSizeDetail.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("sizeDetail")}
            margin="normal"
          />
          <CommonTextField
            label={<TXT name="wordPlaceholder_itemMemo" />}
            value={tempMemo}
            multiline
            shrinkLabel
            errorText={
              getMaxLength("memo") <= tempMemo.length ? (
                <TXT name="msg_inputTextTooLong" />
              ) : undefined
            }
            onChange={handleChange("memo")}
            margin="normal"
          />
        </div>
      }
      firstButtonText={<TXT name="btnModal_cancel" />}
      firstButtonFunc={onClose}
      secondButtonText={<TXT name="btnModal_save" />}
      secondButtonFunc={handleSaveBtnClick}
    />
  );
}

export default ItemNoteInputModalView;
